import sortBy from 'lodash-es/sortBy';

const defaultTransition = {
  id: 'edfbbccb-b259-467c-bed8-670167863d2d',
  name: 'None',
  duration: 0,
  ease: { type: 'Power0', curve: 'easeNone' },
  enter: { from: {}, to: {} },
  exit: { from: {}, to: {} },
};

const otherTransitions = [
  {
    id: '00748b4b-e14c-4ffc-b66d-f2e35b0fdf7b',
    name: 'Cross Fade',
    duration: 1000,
    ease: { type: 'Power3', curve: 'easeOut' },
    enter: { from: { zIndex: 0 }, to: { zIndex: 0 } },
    exit: { from: { opacity: 1, zIndex: 1 }, to: { opacity: 0, zIndex: 1 } },
  },
  {
    id: '1114fced-b943-41d6-ac63-7f0a220f7850',
    name: '3D Flip',
    duration: 1000,
    ease: { type: 'Power3', curve: 'easeOut' },
    enter: {
      from: {
        transformStyle: 'preserve-3d',
        backfaceVisibility: 'hidden',
        transformOrigin: 'center',
        rotationY: -180,
        zIndex: 0,
      },
      to: {
        transformStyle: 'preserve-3d',
        backfaceVisibility: 'hidden',
        transformOrigin: 'center',
        rotationY: '0_ccw',
        zIndex: 1,
      },
    },
    exit: {
      from: {
        transformStyle: 'preserve-3d',
        backfaceVisibility: 'hidden',
        transformOrigin: 'center',
        rotationY: 0,
        zIndex: 1,
      },
      to: {
        transformStyle: 'preserve-3d',
        backfaceVisibility: 'hidden',
        transformOrigin: 'center',
        rotationY: '180_ccw',
        zIndex: 0,
      },
    },
  },
  {
    id: '243bd347-dbb8-436f-843c-451274a1d003',
    name: 'Horizontal Reveal',
    duration: 1000,
    ease: { type: 'Power3', curve: 'easeOut' },
    enter: {
      from: { zIndex: 0, filter: 'brightness(0)' },
      to: { zIndex: 0, opacity: 1, filter: 'brightness(1)' },
    },
    exit: {
      from: { xPercent: 0, zIndex: 1, opacity: 3 },
      to: { xPercent: -110, zIndex: 1, opacity: 0 },
    },
  },
  {
    id: '402db57a-34d6-4cdb-bc4a-7f3f351aad81',
    name: 'Scale Up',
    duration: 1000,
    ease: { type: 'Expo', curve: 'easeOut' },
    enter: { from: { zIndex: 0 }, to: { zIndex: 0 } },
    exit: {
      from: {
        transformStyle: 'preserve-3d',
        transformOrigin: 'center',
        backfaceVisibility: 'hidden',
        scale: 1,
        opacity: 1,
        zIndex: 1,
      },
      to: {
        transformStyle: 'preserve-3d',
        transformOrigin: 'center',
        backfaceVisibility: 'hidden',
        scale: 1.5,
        opacity: 0,
        zIndex: 1,
      },
    },
  },
  {
    id: '46dd2f8c-063e-483a-89a2-7d168e5bb6fc',
    name: 'Horizontal Slide',
    duration: 1000,
    ease: { type: 'Power3', curve: 'easeOut' },
    enter: {
      from: { xPercent: 110, opacity: 0 },
      to: { xPercent: 0, opacity: 1 },
    },
    exit: {
      from: { xPercent: 0, opacity: 1 },
      to: { xPercent: -110, opacity: 0 },
    },
  },
  {
    id: '6ec7b1dd-4597-48d6-8d28-66ea66cde7b7',
    name: 'Vertical Reveal',
    duration: 1000,
    ease: { type: 'Power3', curve: 'easeOut' },
    enter: {
      from: { zIndex: 0, filter: 'brightness(0.5)' },
      to: { zIndex: 0, filter: 'brightness(1)' },
    },
    exit: {
      from: { yPercent: 0, zIndex: 1, opacity: 1 },
      to: { yPercent: -120, zIndex: 1, opacity: 0 },
    },
  },
  {
    id: '7d57d6cb-33cd-4821-86c7-7983db24ad67',
    name: '3D Cube',
    duration: 1000,
    ease: { type: 'Power3', curve: 'easeOut' },
    enter: {
      from: {
        transformStyle: 'preserve-3d',
        backfaceVisibility: 'hidden',
        transformOrigin: 'center center -%%half_width%%px',
        rotationY: 90,
        zIndex: 1,
      },
      to: {
        transformStyle: 'preserve-3d',
        backfaceVisibility: 'hidden',
        transformOrigin: 'center center -%%half_width%%px',
        rotationY: 0,
        zIndex: 1,
      },
    },
    exit: {
      from: {
        transformStyle: 'preserve-3d',
        backfaceVisibility: 'hidden',
        transformOrigin: 'center center -%%half_width%%px',
        rotationY: 0,
        opacity: 1,
        zIndex: 0,
      },
      to: {
        transformStyle: 'preserve-3d',
        backfaceVisibility: 'hidden',
        transformOrigin: 'center center -%%half_width%%px',
        rotationY: -90,
        opacity: 0.5,
        zIndex: 0,
      },
    },
  },
  {
    id: 'a23b8ba5-91bf-4016-8452-783fb6be0bee',
    name: 'Vertical Drop',
    duration: 1000,
    ease: { type: 'Bounce', curve: 'easeOut' },
    enter: {
      from: { yPercent: -110, zIndex: 1 },
      to: { yPercent: 0, zIndex: 1 },
    },
    exit: {
      from: { opacity: 1, zIndex: 0, filter: 'brightness(1)' },
      to: { zIndex: 0, filter: 'brightness(0.5)' },
    },
  },
  {
    id: 'ac401b7f-efc1-44a1-89a5-b57e725f2f05',
    name: 'Scale Down',
    duration: 1000,
    ease: { type: 'Expo', curve: 'easeOut' },
    enter: {
      from: {
        transformStyle: 'preserve-3d',
        transformOrigin: 'center',
        backfaceVisibility: 'hidden',
        scale: 1.5,
        opacity: 0,
        zIndex: 1,
      },
      to: {
        transformStyle: 'preserve-3d',
        transformOrigin: 'center',
        backfaceVisibility: 'hidden',
        scale: 1,
        opacity: 1,
        zIndex: 1,
      },
    },
    exit: { from: { zIndex: 0 }, to: { zIndex: 0 } },
  },
  {
    id: 'c28f2631-d8ae-40d4-be5d-38661732e850',
    name: 'Vertical Slide',
    duration: 1000,
    ease: { type: 'Power3', curve: 'easeOut' },
    enter: {
      from: { yPercent: 100, opacity: 0 },
      to: { yPercent: 0, opacity: 1 },
    },
    exit: {
      from: { yPercent: 0, opacity: 1 },
      to: { yPercent: -110, opacity: 0 },
    },
  },
  {
    id: 'ce23a669-28e7-49de-a891-d0502d1b5e22',
    name: 'Closing Door',
    duration: 1000,
    ease: { type: 'Back', curve: 'easeOut' },
    enter: {
      from: {
        transformStyle: 'preserve-3d',
        transformOrigin: 'left top',
        backfaceVisibility: 'hidden',
        rotationY: -90,
        zIndex: 1,
      },
      to: {
        transformStyle: 'preserve-3d',
        transformOrigin: 'left top',
        backfaceVisibility: 'hidden',
        rotationY: 0,
        zIndex: 1,
      },
    },
    exit: {
      from: { zIndex: 0 },
      to: {
        transformStyle: 'preserve-3d',
        transformOrigin: 'left top',
        backfaceVisibility: 'hidden',
        rotationY: 0,
        opacity: 0,
        zIndex: -1,
      },
    },
  },
  {
    id: 'ea729b41-b6e6-4e7a-9c3e-94efaf0f3797',
    name: 'Squish',
    duration: 1000,
    ease: { type: 'Power3', curve: 'easeOut' },
    enter: {
      from: {
        transformOrigin: 'left bottom',
        scale: 4,
        xPercent: 100,
        zIndex: 1,
      },
      to: { transformOrigin: 'left bottom', scale: 1, xPercent: 0, zIndex: 1 },
    },
    exit: {
      from: {
        transformOrigin: 'left bottom',
        scale: 1,
        zIndex: 0,
        filter: 'brightness(1)',
      },
      to: {
        transformOrigin: 'left bottom',
        scale: 0.5,
        zIndex: 0,
        filter: 'brightness(0.5)',
      },
    },
  },
  {
    id: 'ea9d5e22-7b2d-4c8b-8c54-cf30d29069ca',
    name: 'Corner Rotation',
    duration: 750,
    ease: { type: 'Back', curve: 'easeOut' },
    enter: {
      from: { transformOrigin: 'left bottom', rotationZ: 90, zIndex: 1 },
      to: { transformOrigin: 'left bottom', rotationZ: 0, zIndex: 1 },
    },
    exit: { from: { zIndex: 0 }, to: { zIndex: 0 } },
  },
];

export default [defaultTransition, ...sortBy(otherTransitions, 'name')];
